import React, { useCallback } from 'react'
import { useLocation, useMatches, useNavigate } from 'react-router'
import { useOutlet } from 'react-router-dom'

import Modal from '../basics/Modal/Modal'

import styles from './OverlayChildPage.module.scss'
import { RouteHandle } from '../../routes'

export default React.memo(function OverlayChildPage() {
  const matches = useMatches()
  const navigate = useNavigate()
  const location = useLocation()
  const handleClose = useCallback(() => {
    navigate({
      pathname: matches[matches.length - 2].pathname,
      search: location.search,
    })
  }, [navigate, matches])

  const close = useCallback(() => {
    handleClose()
  }, [handleClose])

  const childPage = useOutlet({ close })

  if (!childPage) {
    return null
  }

  const currentRouteHandle = matches[matches.length - 1]?.handle as RouteHandle

  const styleMap: { [key: string]: string } = {
    courseAsset: styles.CourseAssetsOverlayChildPage,
    // ... other special modal styles for selected routes
  }

  const modalStyle = styleMap[currentRouteHandle?.routeName ?? ''] || styles.OverlayChildPage

  return (
    <Modal className={modalStyle} onClose={handleClose}>
      {childPage}
    </Modal>
  )
})
